export const INSTALLATION_HELP_URL =
  "https://support.merkurysmart.com/hc/en-us";

export const DOORBELL_INSTALLATION_HELP_URL =
  "https://support.merkurysmart.com/hc/en-us/articles/25727679760539-Quick-Links-for-Smart-Doorbell";

export const FLOODLIGHT_INSTALLATION_HELP_URL =
  "https://support.merkurysmart.com/hc/en-us/articles/25737603802267-Wiring-and-Connecting";
